// @mui
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
// theme
import {hideScroll} from 'packages/common/theme/css';
// hooks
import {useAdminBannerOffset} from 'packages/common/hooks/useAdminBannerOffset';
// components
import Logo from 'packages/common/components/logo';
import {NavSectionMini} from 'packages/common/components/nav-section';
//
import {NAV, SAFE_AREA_TOP} from '../config-layout';
import {useNavData} from './config-navigation';
import {NavToggleButton} from '../_common';
import NavFooterSection from './nav-footer-section';

// ----------------------------------------------------------------------

export default function NavMini() {
  const adminBannerOffset = useAdminBannerOffset();

  const navData = useNavData();

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: {lg: 0},
        width: {lg: NAV.W_MINI},
      }}
    >
      <NavToggleButton
        sx={{
          top: `calc(22px + ${SAFE_AREA_TOP})`,
          left: NAV.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: adminBannerOffset ? `calc(100vh - ${adminBannerOffset}px)` : '100vh',
          position: 'fixed',
          top: adminBannerOffset,
          width: NAV.W_MINI,
          bgcolor: (theme) => theme.palette.navy[900],
          borderRight: (theme) => `solid 1px rgba(255, 255, 255, 0.08)`,
          // Barre d'état iOS en PWA : fond navy conservé, contenu décalé (0 ailleurs).
          paddingTop: SAFE_AREA_TOP,
          boxSizing: 'border-box',
          ...hideScroll.x,
        }}
      >
        <Logo variant="white" sx={{mx: 'auto', mt: 1.5, mb: 2}} isSmall />

        <NavSectionMini
          data={navData}
        />

        <Box sx={{flexGrow: 1}} />

        <NavFooterSection isMini />
      </Stack>
    </Box>
  );
}
